import { apiSlice } from "./apiSlice";
import {
  AdoptionLevel,
  AdoptionReportPayload,
  AdoptionReportStatus,
  AdoptionReportVersion,
} from "../../services/adoptionReports/adoptionReports.types";

export interface GenerateAdoptionReportArgs {
  schoolId: number;
  level: AdoptionLevel;
  from?: string;
  to?: string;
}

/** La versión queda en cola: la genera el worker de reportes. */
export interface GenerateAdoptionReportResult {
  id: number;
  report_version: number;
  status: AdoptionReportStatus;
}

/**
 * SCRUM-1557 — reportes de adopción por escuela. Sólo ADMIN: se encolan de a
 * una escuela desde su ficha, los genera el worker de reportes y el PDF se
 * arma en el navegador con el snapshot guardado.
 */
export const adoptionReportsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAdoptionReports: builder.query<
      AdoptionReportVersion[],
      { schoolId: number; level: AdoptionLevel }
    >({
      query: ({ schoolId, level }) => ({
        url: "/admin/adoption-reports",
        method: "GET",
        params: { schoolId, level },
      }),
    }),
    generateAdoptionReport: builder.mutation<
      GenerateAdoptionReportResult,
      GenerateAdoptionReportArgs
    >({
      query: (data) => ({
        url: "/admin/adoption-reports",
        method: "POST",
        data,
      }),
    }),
    getAdoptionReport: builder.query<AdoptionReportPayload, number>({
      query: (id) => ({
        url: `/admin/adoption-reports/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetAdoptionReportsQuery,
  useGenerateAdoptionReportMutation,
  useLazyGetAdoptionReportQuery,
} = adoptionReportsApi;
